import { queryOptions } from '@tanstack/react-query';
import AuthService from './auth.service';
import { queryClient } from '@/lib/queryClient';

export const createPingQueryOptions = () => {
  const authService = AuthService();
  return queryOptions({
    queryKey: ['ping'],
    queryFn: async () => {
      return new Promise(async (resolve) => {
        const response = await authService.getPing();
        // console.log(response)
        resolve(response);
        return response;
      });
    },
    ...queryClient.defaultQueryOptions,
    // cacheTime: 0,
    // refetchOnWindowFocus: true,
    // retry: false
  });
};


export const createUserQueryOptions = ({ ticketid, customerid, limittocustomer, auth }: any) => {
  const authService = AuthService();
  return queryOptions({
    queryKey: ['agentContext', ticketid, customerid, limittocustomer],
    queryFn: async () => {
      const response = await authService.getAgentContext({ customerid, ticketid, limittocustomer });
      // auth.updateUser(response)
      return response;
    },
    ...queryClient.defaultQueryOptions,
    enabled: (!!ticketid && !!customerid && !!limittocustomer) ? false : true,
  });
};